import { Gear, Blinker, EmergencyMode, ControlMode } from 'core/models/drive';

export namespace VehicleController {
    export enum EventType {
        Accel = 'accel',
        Brake = 'brake',
        Steering = 'steering',
    }

    export interface AccelEvent {
        eventType: 'accel';
        accel: number; /* 0.0 ... 1.0 */
    }

    export interface BrakeEvent {
        eventType: 'brake';
        brake: number; /* 0.0 ... 1.0 */
    }

    export interface SteeringEvent {
        eventType: 'steering';
        steering: number; /* -1.0 ... 1.0 */
    }

    export interface GearEvent {
        eventType: 'gear';
        gear: Gear;
    }

    export interface BlinkerEvent {
        eventType: 'blinker';
        blinker: Blinker | null;
    }

    export interface EmergencyEvent {
        eventType: 'emergency';
        emergency: EmergencyMode;
    }

    export interface ControlModeEvent {
        eventType: 'controlMode';
        controlMode: ControlMode;
    }

    export type Event =
        SteeringEvent
        | AccelEvent | BrakeEvent
        | GearEvent
        | BlinkerEvent
        | EmergencyEvent
        | ControlModeEvent
        ;

    export type EventListener = (event: Event) => void;
}

export interface VehicleController {
    addEventListener(listener: VehicleController.EventListener): void;
    removeEventListener(listener: VehicleController.EventListener): void;

    pushEvent(event: VehicleController.Event): void;
}
